$( function() {
    var slider = $( "#slider-range" );

    slider.slider({
      range: true,
      min: slider.data("min"),
      max: slider.data("max"),
      values: [ slider.data("min-value"), slider.data("max-value") ],
      slide: function( event, ui ) {
        $( "#min-price" ).val( ui.values[ 0 ] );
        $( "#max-price" ).val( ui.values[ 1 ] );
        $(".min-price").html( $( "#min-price" ).val() + "лв.");
        $(".max-price").html( $( "#max-price" ).val() + "лв.");
      }
    });
    $( "#min-price" ).val(slider.slider( "values", 0 ) );
    $( "#max-price" ).val(slider.slider( "values", 1 ) );
    $(".min-price").html( $( "#min-price" ).val() + "лв.");
    $(".max-price").html( $( "#max-price" ).val() + "лв.");
  } );

